import React, { Fragment } from "react";
import { v4 as uuidv4 } from "uuid";
import Stack from "@vapor/react-material/Stack";
import Divider from "@vapor/react-material/Divider";
import Button from "@vapor/react-material/Button";
import Table from "@vapor/react-material/Table";
import TableContainer from "@vapor/react-material/TableContainer";
import TableCell from "@vapor/react-material/TableCell";
import TableBody from "@vapor/react-material/TableBody";
import TableHead from "@vapor/react-material/TableHead";
import TableRow from "@vapor/react-material/TableRow";
import Paper from "@vapor/react-material/Paper";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const ImportFinishedPanel = ({
  t,
  importedCount,
  importErrors,
  onNewImport,
}) => {
  return (
    <Fragment>
      <Stack direction="row" sx={{ mb: 3 }}>
        <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
          <ExtendedTypography variant="titleSmall" color="primary.main">
            {t("anagrafica.ImportDesktop.esito")}
          </ExtendedTypography>
          <Divider variant="standard" />
          <ExtendedTypography variant="titleSmall" color="primary.main">
            {importedCount} {t("anagrafica.ImportDesktop.impFasc")}
          </ExtendedTypography>
          <Divider variant="standard" />
          <ExtendedTypography variant="titleSmall" color="primary.main">
            {importErrors.length} {t("anagrafica.ImportDesktop.nonImpFasc")}
          </ExtendedTypography>

          {importErrors.length > 0 ? (
            <Fragment>
              <TableContainer component={Paper}>
                <Table size="medium">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">{t("anagrafica.ImportDesktop.codFisc")}</TableCell>
                      <TableCell align="left">{t("dashboard.piva")}</TableCell>
                      <TableCell align="left">{t("anagrafica.ImportDesktop.denom")}</TableCell>
                      <TableCell align="left">{t("anagrafica.ImportDesktop.motivo")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {importErrors.map((item) => (
                      <TableRow
                        key={uuidv4()}
                        hover
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell component="th" scope="row" sx={{ pl: 1 }} align="left">
                          {item.cf}
                        </TableCell>
                        <TableCell component="th" scope="row" sx={{ pl: 1 }} align="left">
                          {item.pIva}
                        </TableCell>
                        <TableCell component="th" scope="row" sx={{ pl: 1 }} align="left">
                          {item.denominazione}
                        </TableCell>
                        <TableCell component="th" scope="row" sx={{ pl: 1 }} align="left">
                          {item.reason}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Fragment>
          ) : null}
        </Stack>
      </Stack>
      <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
        <Button variant="contained" size="medium" onClick={onNewImport}>
          {t("anagrafica.ImportDesktop.newImport")}
        </Button>
      </Stack>
    </Fragment>
  );
};
